var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('KIcon',{staticClass:"icon-1",attrs:{"icon":"helpOutline"}}),_vm._v(" "),_c('KIcon',{staticClass:"icon-2",attrs:{"icon":"helpOutline"}}),_vm._v(" "),_c('KIcon',{staticClass:"icon-3",attrs:{"icon":"helpOutline"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }